import { BaseEntity } from "yt-ng-framework";

export class UserIPAddress extends BaseEntity{
    constructor(){
        super();
    }

   // ID: number = null
    UserId: number = null;
    IPAddress: string = null;
    Ime: string = null;
    Prezime: string = null;


    Deserialize(input: any){
        this.ID = input.ID;
        this.UserId = input.UserId;
        this.IPAddress = input.IPAddress;
        this.Ime = input.Ime;
        this.Prezime = input.Prezime;
        return this;
    }

    Serialize(input: UserIPAddress): {} {
        return input;
    }
}